import ekozAxios from './instance/axios';

export const readRoles = () => ekozAxios.request({
  method: 'get',
  url: '/roles/get_roles.php',
});
